<template>
  <a-config-provider
    :theme="{
      algorithm: algorithm,
      token: {
        colorPrimary: theme.color,
        colorLink: theme.color,
      },
    }">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>
<script setup>
import { theme as antdvTheme } from 'ant-design-vue';
import theme from '@/themes'
const algorithm = (theme.type === 'dark') ? antdvTheme.darkAlgorithm : antdvTheme.defaultAlgorithm
</script>
<script>
export default {
  name: 'App',
  mounted() {
    document.querySelector('html').setAttribute('data-theme', theme.type)
  },
}
</script>
